import type { ChannelDataSetAccent } from "@mlx/contracts";

// Each accent binds --ds-tone and --ds-foreground to an existing badge token
// pair, so accent-scoped styles stay static Tailwind classes and both themes are
// handled by the tokens. Kept free of runtime contract imports so surfaces
// that render records from static data can colour option badges too.
const ACCENT_TONE_CLASS: Record<ChannelDataSetAccent, string> = {
  sky: "[--ds-tone:var(--badge-sky-tone)] [--ds-foreground:var(--badge-sky-foreground)]",
  violet:
    "[--ds-tone:var(--badge-violet-tone)] [--ds-foreground:var(--badge-violet-foreground)]",
  teal: "[--ds-tone:var(--badge-teal-tone)] [--ds-foreground:var(--badge-teal-foreground)]",
  amber:
    "[--ds-tone:var(--badge-amber-tone)] [--ds-foreground:var(--badge-amber-foreground)]",
  green:
    "[--ds-tone:var(--badge-green-tone)] [--ds-foreground:var(--badge-green-foreground)]",
  orange:
    "[--ds-tone:var(--badge-orange-tone)] [--ds-foreground:var(--badge-orange-foreground)]",
  red: "[--ds-tone:var(--badge-red-tone)] [--ds-foreground:var(--badge-red-foreground)]",
  blue: "[--ds-tone:var(--badge-blue-tone)] [--ds-foreground:var(--badge-blue-foreground)]",
  plum: "[--ds-tone:var(--badge-plum-tone)] [--ds-foreground:var(--badge-plum-foreground)]",
  pink: "[--ds-tone:var(--badge-pink-tone)] [--ds-foreground:var(--badge-pink-foreground)]",
  rose: "[--ds-tone:var(--badge-rose-tone)] [--ds-foreground:var(--badge-rose-foreground)]",
  lime: "[--ds-tone:var(--badge-lime-tone)] [--ds-foreground:var(--badge-lime-foreground)]",
  stone:
    "[--ds-tone:var(--badge-stone-tone)] [--ds-foreground:var(--badge-stone-foreground)]",
  slate:
    "[--ds-tone:var(--badge-slate-tone)] [--ds-foreground:var(--badge-slate-foreground)]",
};

export function dataSetAccentToneClass(accent: ChannelDataSetAccent): string {
  return ACCENT_TONE_CLASS[accent];
}
